module.exports = __webpack_public_path__ + "img/logo7.b4df539b.png";